/* global System */

export default {
  Infomodul: () => System.import(/* webpackChunkName: "Infomodul" */ './index'),
}
